export default "__VITE_ASSET__FacmmYGv__"